import Store from '@projectTypes/Store';

export const leftSidebarSelector = (state: Store) => state.global.isLeftSidebarOpen;
export const rightSidebarSelector = (state: Store) => state.global.isRightSidebarOpen;

export const fontSizeSelector = (state: Store) => state.global.fontSize;
